export default {
    'ERROR-GET-TEAMSPACES': {
    // No custom service errors thrown (safe fetch)
    },
    'ERROR-GET-TEAMSPACES-ORGANIZATION': {
    // No custom service errors thrown (safe fetch)
    },
    'ERROR-POST-TEAMSPACE': {
        'TEAMSPACE-NAME-ALREADY-EXISTS': {
            actionType: 'toast',
            message: {
                fr: "Un teamspace avec ce nom existe déjà.",
                en: "A teamspace with this name already exists.",
            },
        },
    },
    'ERROR-UPDATE-TEAMSPACE': {
        'TEAMSPACE-NOT-FOUND': {
            actionType: 'redirect',
            message: {
                fr: "Teamspace introuvable.",
                en: "Teamspace not found.",
            },
            redirectPath: '/',
        },
        'TEAMSPACE-NAME-ALREADY-EXISTS': {
            actionType: 'toast',
            message: {
                fr: "Un teamspace avec ce nom existe déjà.",
                en: "A teamspace with this name already exists.",
            },
        },
    },
    'ERROR-DELETE-TEAMSPACE': {
        'TEAMSPACE-ORGANIZATION-LAST-TEAMSPACE': {
            actionType: 'toast',
            message: {
                fr: "Vous ne pouvez pas supprimer le dernier teamspace de l'organisation.",
                en: "You cannot delete the organization's last teamspace.",
            },
        },
        'TEAMSPACE-NOT-FOUND': {
            actionType: 'redirect',
            message: {
                fr: "Teamspace introuvable.",
                en: "Teamspace not found.",
            },
            redirectPath: '/',
        },
        'TEAMSPACE-HAS-AMBASSADORS': {
            actionType: 'toast',
            message: {
                fr: "Impossible de supprimer un teamspace ayant des ambassadeurs.",
                en: "Cannot delete a teamspace that has ambassadors.",
            },
        },
        'AMBASSADOR-HAS-RELATIONS': {
            actionType: 'toast',
            message: {
                fr: "Impossible de supprimer un ambassadeur ayant des relations.",
                en: "Cannot delete an ambassador with relations.",
            },
        }
    },
};
